/* eslint-disable no-console */
/* eslint-disable sort-keys */
/* eslint-disable import/max-dependencies */
/* eslint-disable max-lines */
import React, {
  useEffect,
  useRef,
  useState,
  useMemo,
  useCallback,
} from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Badge from '@mui/material/Badge';

import { Popover } from '@im/ui-lib/zenith/Popover';
import { HorizontalTabs } from '@im/ui-lib/zenith/Tabs';
import { Icon } from '@im/ui-lib/zenith/Icon';
import { StatusBadge } from '@im/ui-lib/zenith/StatusBadge';
import { FeaturedIcon } from '@im/ui-lib/zenith/FeaturedIcon';
import { ImThemeProviderZenith } from '@im/im-theme';
import { MuiProviders } from '@im/ui-lib/theme/MuiProviders';
import { DropdownMenu } from '@im/ui-lib/zenith/DropdownMenu/DropdownMenu';
import { EmptyStateIllustration } from '@im/ui-lib/zenith/EmptyStateIllustration';
import { useMarkAsReadNotifications } from '../../hooks/use-markAsReadForNotifications';
import { useFirebaseLoader } from '../../app/injectors/useFirebase';
import { useFeatureFlag } from 'mf_core/feature-flag';
import { FCMEnabler } from './FCMEnabler';
import { useNavigate } from 'react-router-dom';
import { useIsImpersonationMode } from 'mf_core/auth';
import { useTheme } from '@mui/material/styles';

export function NotificationZenith() {
  const navigate = useNavigate();
  const theme = useTheme();
  const [isPopoverOpen, setIsPopoverOpen] = useState<boolean>(false);
  const [allChat, setAllChat] = useState<any>([]);
  const [allHistoryChat, setAllHistoryChat] = useState<any>([]);
  const [unreadChat, setUnreadChat] = useState<any>([]);
  const [unreadHistoryChat, setUnreadHistoryChat] = useState<any>([]);
  const [dismissedIds, setDismissedIds] = useState<Set<string>>(new Set());
  const [readIds, setReadIds] = useState<Set<string>>(new Set());
  const allLatestChat = useRef<any>(null);
  allLatestChat.current = allChat;
  const unreadLatestChat = useRef<any>(null);
  unreadLatestChat.current = unreadChat;
  const [fcmToken, setFcmtoken] = useState('');
  const isImpersonationMode = useIsImpersonationMode();
  const [selectType, setSelectType] = useState<string>('Unread');
  const [unreadMessagesHistoryCount, setUnreadMessagesHistoryCount] =
    useState<any>([]);
  const handleTabChange = (event: React.SyntheticEvent, newKey: string) => {
    setSelectedTabKey(newKey);
    setSelectType(newKey);
  };
  const { isReady, value: boData } = useFeatureFlag([
    'im-customer-usermanagement-notificationsettingzenithview-isenabled',
    'im-customer-usermanagement-notificationsettingzenithview-isenabled-whitelistedresellers',
    'im-customer-accmgmt-v2webinapp-isenabled',
  ]);
  const firebaseReady = useFirebaseLoader();
  const [allHasMore, setAllHasMore] = useState(true);
  const [unreadHasMore, setUnreadHasMore] = useState(true);
  const [allIsLoading, setAllIsLoading] = useState(false);
  const [unreadIsLoading, setUnreadIsLoading] = useState(false);
  const [unreadToDate, setUnreadToDate] = useState('');
  const [allToDate, setAllToDate] = useState('');
  const scrollContainerRef = useRef<HTMLDivElement | null>(null);
  const [resetPagination, setResetPagination] = useState(0);

  //pass the readStatus and toDate to invalidate the query properly
  const useMarkAsReadNotification = useMarkAsReadNotifications(
    selectType === 'All' ? allToDate : unreadToDate
  );

  const loadNextPage = useCallback(() => {
    if (selectType === 'All') {
      setAllIsLoading(true);
      if (allHistoryChat.length > 0) {
        setAllToDate(allHistoryChat[allHistoryChat.length - 1].createdDate);
      }
    } else {
      setUnreadIsLoading(true);
      if (unreadHistoryChat.length > 0) {
        setUnreadToDate(
          unreadHistoryChat[unreadHistoryChat.length - 1].createdDate
        );
      }
    }
  }, [selectType, allHistoryChat, unreadHistoryChat]);
  useEffect(() => {
    // Only enable infinite scroll if the feature flag is true
    if (boData['im-customer-accmgmt-v2webinapp-isenabled'] !== 'true') {
      return;
    }
    const container = scrollContainerRef.current;
    if (!container) {
      return;
    }

    let debounceTimeout: NodeJS.Timeout | null = null;
    const handleScroll = () => {
      if (debounceTimeout) {
        clearTimeout(debounceTimeout);
      }
      debounceTimeout = setTimeout(() => {
        const { clientHeight, scrollHeight, scrollTop } = container;
        const isAtBottom = scrollTop + clientHeight >= scrollHeight - 50;
        if (isAtBottom && scrollTop > 0) {
          loadNextPage();
        }
      }, 150);
    };
    container.addEventListener('scroll', handleScroll);
    return () => {
      container.removeEventListener('scroll', handleScroll);
    };
  }, [
    allHasMore,
    allIsLoading,
    boData,
    loadNextPage,
    selectType,
    unreadHasMore,
    unreadIsLoading,
  ]);
  const showNotificationBellIcon = useMemo(() => {
    return (
      boData[
        'im-customer-usermanagement-notificationsettingzenithview-isenabled'
      ] === 'true' &&
      boData[
        'im-customer-usermanagement-notificationsettingzenithview-isenabled-whitelistedresellers'
      ] === 'true'
    );
  }, [boData]);
  const notificationTabs = [
    {
      badge: true,
      badgeLabel: unreadMessagesHistoryCount,
      'data-name': 'Unread_Notifications',
      key: 'Unread',
      label: 'Unread',
    },
    { 'data-name': 'All_Notifications', key: 'All', label: 'All' },
  ];
  const [selectedTabKey, setSelectedTabKey] = useState(notificationTabs[0].key);
  const listener = useCallback(
    (event: MessageEvent) => {
      if (!event?.data) return;

      const notificationType =
        event.data?.data?.notificationType || event.data?.notificationType;
      const title = event.data?.data?.title || 'Notification';
      const content = event.data?.data?.content || '';

      if (notificationType === 'push') {
        console.log('[ServiceWorker] Browser PUSH notification received:', {
          title,
          content,
          notificationType,
        });

        if (Notification.permission === 'granted') {
          new Notification(title, {
            body: content,
            icon: '/icons/notification-icon.png', // optional icon
          });
        } else if (Notification.permission !== 'denied') {
          Notification.requestPermission().then((permission) => {
            if (permission === 'granted') {
              new Notification(title, {
                body: content,
                icon: '/icons/notification-icon.png',
              });
            }
          });
        }
        return; // prevent push messages from showing in the bell list
      }

      if (notificationType !== 'inapp') {
        console.log(
          '[ServiceWorker] Ignored non-inapp notification:',
          notificationType
        );
        return;
      }

      const isAll = selectType === 'All';
      const updatedChat = isAll
        ? [...allLatestChat.current]
        : [...unreadLatestChat.current];

      const incomingId =
        event.data?.data?.notificationId || event.data?.notificationId;

      const isDuplicate = updatedChat.some((item) => {
        const existingId = item?.data?.notificationId || item?.notificationId;
        return existingId && incomingId && existingId === incomingId;
      });

      if (!isDuplicate) {
        const newMessage = {
          ...event.data,
          content: event.data?.data?.content ?? '',
          createdDate: new Date().toISOString(),
          isRead: false,
          notificationId:
            event.data?.data?.notificationId ?? event.data?.notificationId,
          title: event.data?.data?.title ?? '',
        };

        const newChatArray = [...updatedChat, newMessage];
        const deduplicated = removeDuplicate(newChatArray);
        if (isAll) {
          setAllChat(deduplicated);
        } else {
          setUnreadChat(deduplicated);
        }
      }

      return () => {
        navigator?.serviceWorker?.removeEventListener('message', listener);
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [selectType, setAllChat, setUnreadChat]
  );
  useEffect(() => {
    if (
      typeof window !== 'undefined' &&
      'serviceWorker' in navigator &&
      typeof navigator.serviceWorker?.addEventListener === 'function'
    ) {
      navigator.serviceWorker.addEventListener('message', listener);
      return () => {
        navigator.serviceWorker.removeEventListener('message', listener);
      };
    } else {
      console.warn('Service worker not supported. Skipping listener setup.');
    }
  }, [listener]);

  const getNotificationId = (item: any) =>
    item?.data?.notificationId || item?.notificationId;
  const markNotificationAsRead = (id: string) => {
    setReadIds((prev) => new Set(prev).add(id));
    setUnreadHistoryChat((prev: any) =>
      prev.filter((notif: any) => getNotificationId(notif) !== id)
    );
    setAllChat((prev: any) =>
      prev.map((notif: any) =>
        getNotificationId(notif) === id ? { ...notif, isRead: true } : notif
      )
    );
  };
  const subscriberId = localStorage.getItem('subscriberid');
  const markAsReadItem = (item: any) => {
    const id = getNotificationId(item);
    markNotificationAsRead(id);

    useMarkAsReadNotification.mutate(
      {
        notificationIds: [id],
        notificationStatus: 'read',
        subscriberId: subscriberId,
      },
      {
        onSuccess: () => {
          setResetPagination((prev) => prev + 1);
        },
      }
    );
  };
  const dismiss = (item: any) => {
    const id = getNotificationId(item);
    setDismissedIds((prev) => new Set(prev).add(id));
    setUnreadHistoryChat((prev: any) =>
      prev.filter((notif: any) => getNotificationId(notif) !== id)
    );
    setAllHistoryChat((prev: any) =>
      prev.filter((notif: any) => getNotificationId(notif) !== id)
    );
    useMarkAsReadNotification.mutate({
      notificationIds: [getNotificationId(item)],
      notificationStatus: 'delete',
      subscriberId: subscriberId,
    });
  };

  const onNotificationItemClick = (item: any) => {
    const id = getNotificationId(item);
    markNotificationAsRead(id);
    useMarkAsReadNotification.mutate({
      notificationIds: [getNotificationId(item)],
      notificationStatus: 'read',
      subscriberId: subscriberId,
    });
  };

  const removeDuplicate = (notifications: any[]) => {
    const result: any[] = [];

    notifications.forEach((item, index, self) => {
      const id = getNotificationId(item);
      if (!id) return;

      const isFirst =
        index ===
        self.findIndex((data) => {
          return getNotificationId(data) === id;
        });

      if (isFirst) {
        result.push(item);
      }
    });

    result.sort(
      (a, b) =>
        new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime()
    );

    return result.map((item) => {
      const content = item.content ?? '';
      const anchorTagRegex = /<a\s+href="(.*?)">(.*?)<\/a>/g;

      const elements: (string | JSX.Element)[] = [];
      let lastIndex = 0;
      let match;

      while ((match = anchorTagRegex.exec(content)) !== null) {
        if (match.index > lastIndex) {
          elements.push(content.substring(lastIndex, match.index));
        }

        const [fullMatch, href, text] = match;

        elements.push(
          <a
            href={href}
            key={`${href}-${match.index}`}
            rel="noopener noreferrer"
            style={{ color: '#1976d2', textDecoration: 'underline' }}
            target="_blank"
          >
            {text}
          </a>
        );

        lastIndex = match.index + fullMatch.length;
      }

      return {
        action: undefined,
        content: parseNotificationContent(item.content ?? ''),
        ...item,
      };
    });
  };
  const parseNotificationContent = (content: string): JSX.Element => {
    const anchorTagRegex = /<a\s+href="(.*?)">(.*?)<\/a>/g;

    const elements: (string | JSX.Element)[] = [];
    let lastIndex = 0;
    let match;

    while ((match = anchorTagRegex.exec(content)) !== null) {
      if (match.index > lastIndex) {
        elements.push(content.substring(lastIndex, match.index));
      }

      const [fullMatch, href, text] = match;

      elements.push(
        <a
          href={href}
          key={`${href}-${match.index}`}
          rel="noopener noreferrer"
          style={{ color: '#1976d2', textDecoration: 'underline' }}
          target="_blank"
        >
          {text}
        </a>
      );

      lastIndex = match.index + fullMatch.length;
    }

    if (lastIndex < content.length) {
      elements.push(content.substring(lastIndex));
    }

    return <span>{elements}</span>;
  };

  const allNotifications = useMemo(
    () => removeDuplicate([...allChat, ...allHistoryChat]),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [allChat, allHistoryChat]
  );
  const unreadNotifications = useMemo(
    () => removeDuplicate([...unreadChat, ...unreadHistoryChat]),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [unreadChat, unreadHistoryChat]
  );
  const filteredNotifications = useMemo(() => {
    if (selectedTabKey === 'Unread') {
      // Unread tab: show notifications not dismissed and not marked as read
      return unreadNotifications.filter(
        (notif) =>
          !dismissedIds.has(getNotificationId(notif)) &&
          !readIds.has(getNotificationId(notif))
      );
    } else {
      // All tab: show notifications not dismissed (read or unread both shown)
      return allNotifications.filter(
        (notif) => !dismissedIds.has(getNotificationId(notif))
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    allNotifications,
    isPopoverOpen,
    unreadNotifications,
    selectedTabKey,
    dismissedIds,
    readIds,
  ]);
  // Compute notification IDs dynamically
  const notificationIds = useMemo(() => {
    const source =
      selectedTabKey === 'Unread'
        ? unreadNotifications
        : allNotifications.filter((n) => !n.isRead);

    return source
      .map((item) => item?.data?.notificationId || item?.notificationId)
      .filter(Boolean);
  }, [selectedTabKey, unreadNotifications, allNotifications]);

  const hasNotificationsToMark = notificationIds.length > 0;

  const markAllAsRead = async () => {
    setIsPopoverOpen(true);
    if (!hasNotificationsToMark) return;

    setReadIds((prev) => {
      const newSet = new Set(prev);
      notificationIds.forEach((id) => newSet.add(id));
      return newSet;
    });

    setUnreadHistoryChat((prev: any) =>
      prev.filter(
        (item: any) =>
          !notificationIds.includes(
            item?.data?.notificationId || item?.notificationId
          )
      )
    );

    if (selectedTabKey === 'Unread') {
      setSelectedTabKey('Unread');
    } else {
      setSelectedTabKey('All');
    }

    useMarkAsReadNotification.mutate(
      {
        notificationIds,
        notificationStatus: 'read',
        subscriberId: subscriberId,
      },
      {
        onSuccess: () => {
          setAllChat((prev: any) =>
            prev.map((notif: any) =>
              notificationIds.includes(
                notif?.data?.notificationId || notif?.notificationId
              )
                ? { ...notif, isRead: true }
                : notif
            )
          );
        },
      }
    );
  };

  const notificationIconRef = useRef<HTMLButtonElement>(null);

  return (
    <>
      {showNotificationBellIcon && !isImpersonationMode && (
        <IconButton
          onClick={() => setIsPopoverOpen(true)}
          ref={notificationIconRef}
          sx={{
            backgroundColor: isPopoverOpen ? '#EEF2F6' : 'inherit',
          }}
        >
          <Badge
            badgeContent={
              unreadMessagesHistoryCount > 50
                ? '50+'
                : unreadMessagesHistoryCount
            }
            color="error"
            max={999}
            sx={{
              '& .MuiBadge-anchorOriginTopRightRectangular.MuiBadge-badge': {
                width: 'fit-content',
                backgroundColor: theme.palette.error[600],
              },
            }}
          >
            <Icon iconId="BellOne" />
          </Badge>
          {/* </StatusBadge> */}
        </IconButton>
      )}
      <ImThemeProviderZenith>
        <MuiProviders>
          {isReady && showNotificationBellIcon && (
            <FCMEnabler
              chat={selectType === 'All' ? allChat : unreadChat}
              fcmToken={fcmToken}
              firebaseReady={firebaseReady}
              historyChat={
                selectType === 'All' ? allHistoryChat : unreadHistoryChat
              }
              latestChat={
                selectType === 'All' ? allLatestChat : unreadLatestChat
              }
              readIds={readIds}
              resetPagination={resetPagination}
              selectedTabKey={selectType}
              setChat={selectType === 'All' ? setAllChat : setUnreadChat}
              setFcmtoken={setFcmtoken}
              setHasMore={
                selectType === 'All' ? setAllHasMore : setUnreadHasMore
              }
              setHistoryChat={
                selectType === 'All' ? setAllHistoryChat : setUnreadHistoryChat
              }
              setIsLoading={
                selectType === 'All' ? setAllIsLoading : setUnreadIsLoading
              }
              setNotificationCount={setUnreadMessagesHistoryCount}
              toDate={selectType === 'All' ? allToDate : unreadToDate}
            />
          )}
          {showNotificationBellIcon && !isImpersonationMode && (
            <Box>
              <Popover
                actions
                anchorEl={notificationIconRef}
                buttonXClose={false}
                featuredIcon="AlertCircle"
                featuredIconColor="gray"
                featuredIconSize="sm"
                featuredIconTheme="outline"
                footerDivider
                footerType="horizontal-right-aligned"
                headerText="Notifications"
                hideHeader
                onClose={() => {
                  setIsPopoverOpen(false);
                  setAllToDate('');
                  setUnreadToDate('');
                  setAllHasMore(true);
                  setUnreadHasMore(true);
                  setAllIsLoading(false);
                  setUnreadIsLoading(false);
                  setResetPagination((prev) => prev + 1);
                  setSelectedTabKey('Unread');
                }}
                open={isPopoverOpen}
                popoverTriggerProps={{
                  triggerType: 'Custom',
                }}
                secondaryButtonProps={{
                  id: 'secondary',
                  onClick: markAllAsRead,
                  startIcon:
                    unreadMessagesHistoryCount > 0 && hasNotificationsToMark ? (
                      <>
                        <Divider sx={{ my: 1 }} />
                        <Stack alignItems="center" direction="row" spacing={1}>
                          <Icon iconId="CheckCircleBroken" />
                          <Typography
                            data-name="Mark all as read_Notifications"
                            variant="text-sm-semibold"
                          >
                            Mark all as read
                          </Typography>
                        </Stack>
                      </>
                    ) : null,
                }}
                showFeaturedIcon
                tipPlacement="Bottom Center"
                width={420}
              >
                <>
                  <Stack
                    alignItems="center"
                    direction="row"
                    justifyContent="space-between"
                    px={2}
                    py={1}
                  >
                    <Typography variant="text-lg-semibold">
                      Notifications
                    </Typography>
                    <FeaturedIcon
                      Icon="SettingsTwo"
                      color="gray"
                      onClick={() => {
                        navigate('/my/account/AccountSettings', {
                          state: { selectedTab: 'notificationSetting' },
                        });
                      }}
                      size="sm"
                      sx={{
                        cursor: 'pointer',
                        backgroundColor: 'transparent',
                        '&:hover': {
                          backgroundColor: '#EEF2F6',
                        },
                      }}
                    />
                  </Stack>

                  <Box px={2}>
                    <HorizontalTabs
                      aria-label="activity tabs"
                      fullWidth
                      onTabChange={handleTabChange}
                      selectedTabKey={selectedTabKey}
                      size="sm"
                      tabs={notificationTabs}
                      type="underline"
                    />
                  </Box>

                  <Box
                    maxHeight="360px"
                    maxWidth="420px"
                    ref={scrollContainerRef}
                    sx={{
                      boxSizing: 'border-box',
                      mb: 1,
                      mt: 1,
                      overflowX: 'hidden',
                      overflowY: 'auto',
                      pr: 1,
                      px: 2,
                    }}
                    width="100%"
                  >
                    {filteredNotifications.length === 0 ? (
                      <Stack
                        alignItems="center"
                        height={300}
                        justifyContent="center"
                      >
                        <EmptyStateIllustration
                          id="bin"
                          sx={{ height: '144px', width: '144px' }}
                        />
                        <Typography variant="text-xl-semibold">
                          You are all up to date
                        </Typography>
                        <Typography>
                          There are no unread notifications
                        </Typography>
                      </Stack>
                    ) : (
                      filteredNotifications.map((item, i) => (
                        <Stack
                          alignItems="flex-start"
                          direction="row"
                          key={i}
                          pt={2}
                          spacing={2}
                          sx={{ width: '100%', wordBreak: 'break-word' }}
                        >
                          <Stack
                            alignItems="center"
                            justifyContent="center"
                            position="relative"
                            width="32px"
                          >
                            {!item?.isRead && (
                              <StatusBadge
                                append
                                label={String(1)}
                                status="default"
                                sx={{
                                  '& .MuiBadge-badge': {
                                    left: '-7px !important',
                                    width: '0px !important',
                                    height: '8px !important',
                                    top: '0px !important',
                                  },
                                  position: 'absolute',
                                  right: 3,
                                  top: 3,
                                  width: '1px',
                                  height: '1px',
                                  borderRadius: '50%',
                                  fontSize: '0.75em',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                }}
                                type="dot"
                              />
                            )}
                            <FeaturedIcon
                              Icon={item?.isRead ? 'PackageCheck' : 'Package'}
                              color="gray"
                              iconTheme="light-circle"
                              size="sm"
                            />
                          </Stack>

                          <Stack
                            alignItems="flex-start"
                            direction="column"
                            onClick={() => onNotificationItemClick(item)}
                            spacing={0.5}
                            sx={{
                              cursor: 'pointer',
                              backgroundColor: 'transparent',
                              '&:hover': {
                                backgroundColor: '#EEF2F6',
                              },
                            }}
                            width="100%"
                          >
                            <Typography variant="text-sm-semibold">
                              {item.title || 'No title'}
                            </Typography>
                            <Typography variant="text-sm-medium">
                              {parseNotificationContent(item.content) ||
                                'No content'}
                            </Typography>

                            <Typography variant="text-xs-regular">
                              {new Date(item.createdDate).toLocaleDateString(
                                'en-US',
                                {
                                  month: 'short',
                                  day: '2-digit',
                                  hour: '2-digit',
                                  minute: '2-digit',
                                  hour12: true,
                                }
                              )}
                            </Typography>
                          </Stack>

                          <Stack>
                            <DropdownMenu
                              menuItemProps={[
                                {
                                  content: 'Mark as read',
                                  'data-name': 'Markasread_Notifications',
                                  disabled: item?.isRead,
                                  id: 'markasread',
                                  onClick: () => markAsReadItem(item),
                                },
                                {
                                  content: 'Dismiss',
                                  'data-name': 'Dismiss_Notifications',
                                  id: 'dismiss',
                                  onClick: () => dismiss(item),
                                },
                              ]}
                              menuMaxWidth="240px"
                              menuTriggerProps={{
                                icon: <Icon iconId="DotsHorizontal" />,
                                triggerType: 'Icon',
                              }}
                              sx={{ overflow: 'hidden' }}
                            />
                          </Stack>
                        </Stack>
                      ))
                    )}
                  </Box>
                </>
              </Popover>
            </Box>
          )}
        </MuiProviders>
      </ImThemeProviderZenith>
    </>
  );
}
